import React from "react";
import Layout from "../features/nav/Layout";
import ErrorPage from "next/error";

export default function Custom404() {
    return <Layout mainContent={
        <ErrorPage statusCode={404}/>
    }/>
}